import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Chest_Clinincs = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
            <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Chest Clinics")} </h3>
                  </div>
                  <div className="health-dept-table" style={{ width: "100%" }}>
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td width="7%" className="text-white tble-brder-left">
                            {t("Sl.No")}.
                          </td>
                          <td width="33%" className="text-white">
                            {t("Name")}
                          </td>
                          <td
                            width="42%"
                            className="text-white tble-brder-right"
                          >
                            {t("Address")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            1
                          </td>
                          <td width="33%">
                            {t("D.T.C ( Tangra Chest Clinic)")}
                          </td>
                          <td width="42%">
                            {t("15/1, Gobinda Khatick Road, Kolkata - 46")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            2
                          </td>
                          <td width="33%">{t("Baghbazar Chest Clinic")}</td>
                          <td width="42%">
                            {t("78/1, Baghbazar St., Kolkata - 3")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            3
                          </td>
                          <td width="33%">{t("Strand Bank Chest Clinic")}</td>
                          <td width="42%">
                            {t("P-66/1/2, Strand Bank Road, Kolkata - 6")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">4</td>
                          <td>{t("Manicktola Chest Clinic")}</td>
                          <td>
                            {t(
                              "34, Upedra Chandra Bannerjee Road, Kolkata - 54"
                            )}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">5</td>
                          <td>{t("Tangra Chest Clinic")}</td>
                          <td>
                            {t("15/1,Gobinda Khatick Road, Kolkata - 46")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">6</td>
                          <td>{t("Tollygunge Chest Clinic")}</td>
                          <td>{t("Loyalka Road, Tollygonge, Kolkata - 92")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">7</td>
                          <td>{t("Alipore Chest Clinic")}</td>
                          <td>{t("19 B Chetla Hut RD - 27")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">8</td>
                          <td>{t("Mansatola Chest Clinic")}</td>
                          <td>{t("6, Mansatola Lane , Kolkata - 23")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">9</td>
                          <td>{t("Behala Chest Clinic")}</td>
                          <td>
                            {t("2, Raja Ram Mohan Roy Road, Kolkata - 8")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">10</td>
                          <td>
                            {t(
                              "Mother Teresa Memorial TB Hospital & Research Centre"
                            )}
                          </td>
                          <td>{t("Boral Main Road,Kolkata 84,Ward 111")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td align="center">11</td>
                          <td>{t("Hazi Chest Clinic")}</td>
                          <td>{t("21 Hazi Md Mohsin Square, Kolkata 16")}.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Chest_Clinincs;
